import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Typography, CircularProgress, Button, Box, Paper, Alert } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function PaymentSuccess() {
  const [message, setMessage] = useState('Verifying your payment, please wait...');
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verify = async () => {
      const queryParams = new URLSearchParams(location.search);
      const sessionId = queryParams.get('session_id');

      if (!sessionId) {
        setMessage('Payment session ID not found in URL.');
        setIsError(true);
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/verify-payment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ session_id: sessionId }),
        });

        const data = await response.json();

        if (response.ok) {
          setMessage(data.message || 'Payment successful! Your account is activated.');
          setIsError(false);
        } else {
           setMessage(data.error || 'Payment verification failed. Please contact support.');
           setIsError(true);
        }
      } catch (error) {
        console.error('Verification error:', error);
        setMessage('An error occurred during payment verification. Please contact support.');
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    verify();
  }, [location]);

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to right, #e0eafc, #cfdef3)', // Light gradient
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center', borderRadius: 2 }}>
          <Typography variant="h4" gutterBottom sx={{ mb: 3, fontWeight: 'bold', color: '#333' }}>
            Payment Status
          </Typography>

          {isLoading ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <CircularProgress />
              <Typography>{message}</Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              {isError ? (
                 <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />
              ) : (
                 <CheckCircleOutlineIcon sx={{ fontSize: 60, color: 'success.main' }} />
              )}
               <Alert severity={isError ? "error" : "success"} sx={{ width: '100%', justifyContent: 'center' }}>
                 {message}
               </Alert>
              <Button
                variant="contained"
                onClick={() => navigate('/login')} // Navigate to login page
                sx={{ mt: 3 }}
              >
                Proceed to Login
              </Button>
            </Box>
          )}
        </Paper>
      </Container>
    </Box>
  );
}

export default PaymentSuccess; 